import { Icon, Menu2, Menu2Option, usePopoverContext } from '@fox/atoms';
import React from 'react';
import { ThemeContext } from 'styled-components';
import { useAutoDataGridContext } from '../../auto-data-grid/context';
import { GraphColumn } from '../types';

export function SortPopover<T>(props: { col: GraphColumn<T> }) {
	const { col } = props;
	const theme = React.useContext(ThemeContext);

	const { closePopover } = usePopoverContext();
	const { sort, setSortColumn } = useAutoDataGridContext();

	// HACK: This is a band-aid around the fact that most usages of the one-table-to-rule-them-all component define sortable
	// columns (sortable: true), but do not specify the sortIndex property. This would normally be fine for most
	// cases, except the List Builder results table where sortIndex is different from dataIndex and this distinction
	// needs to be made (ie. We need to sort on the column indicated by sortIndex, not dataIndex!)
	//
	// To cater for both use cases, we'll assume sortIndex as "the index" and only fall back to dataIndex iff the column
	// does not specify sortIndex and (sortable == true)
	//
	// The true fix is to kill the sortable property, and infer sortability through whether sortIndex is present or not. This
	// fix is very disruptive due to everything that isn't List Builder defining sortable columns completely wrong, so such
	// a fix can be postponed for later.
	let theIndex = col.sortIndex;
	if (!theIndex && col.sortable) {
		theIndex = col.dataIndex;
	}
	const hasSortApplied = sort?.column === theIndex;

	return (
		<>
			<div style={{ padding: '1rem', display: 'flex', flexDirection: 'column' }}>
				<Menu2>
					<Menu2Option
						label="Sort ascending"
						value="Sort ascending"
						icon={<Icon iconName="Sort" sx={{ width: '17px', marginTop: 0, transform: 'rotate(180deg) scaleX(-1)' }} />}
						onClick={async () => {
							setSortColumn({ column: theIndex, asc: true });
							closePopover(true);
						}}
					/>
					<Menu2Option
						label="Sort descending"
						value="Sort descending"
						icon={<Icon iconName="Sort" sx={{ width: '17px', marginTop: 0 }} />}
						onClick={async () => {
							setSortColumn({ column: theIndex, asc: false });
							closePopover(true);
						}}
					/>
					{hasSortApplied && (
						<div style={{ color: theme.colors.bad }}>
							<Menu2Option
								label="Remove sorting"
								value="Remove sorting"
								icon={<Icon iconName="Delete" sx={{ width: '17px', marginTop: 0, color: theme.colors.bad }} />}
								onClick={async () => {
									setSortColumn(undefined);
									closePopover(true);
								}}
							/>
						</div>
					)}
				</Menu2>
			</div>
		</>
	);
}
